/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Detect_Overlap_LabelInputs */



/**
* | output |
* | --- |
* | "Detect Overlap" |
*
* @param {Style_Guide_Manager_Detect_Overlap_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_detect_overlap_label = /** @type {((inputs?: Style_Guide_Manager_Detect_Overlap_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Detect_Overlap_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Detecter le chevauchement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Überlappung erkennen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rileva sovrapposizione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обнаружение перекрытия")
	if (locale === "es") return /** @type {LocalizedString} */ ("Detectar superposición")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("检测重叠")
	if (locale === "ja") return /** @type {LocalizedString} */ ("重複を検出")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ओवरलैप का पता लगाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Detectar sobreposição")
	return /** @type {LocalizedString} */ ("Detect Overlap")
});